class AccessPermission {
    constructor
    (   
        id,
        name,
        requiredPin,
        requiredCacheo,
        requiredPassBack,
        porcentCacheo,
        visit,
        active)
    {
        this.id = id;
        this.name = name;
        this.requiredPin =requiredPin;
        this.requiredCacheo = requiredCacheo;
        this.reqPassBack=requiredPassBack;
        this.porcentCacheo=porcentCacheo;
        this.visit=visit;
        this.active = active;
    }

    static fromJson({
        permisoId,
        nombre,
        reqPin,
        reqCacheo,
        reqPassBack,
        porcenCacheo,
        visita,
        activo
    }) {
        return new AccessPermission(
            permisoId,
            nombre,
            reqPin,
            reqCacheo,
            reqPassBack,
            porcenCacheo,
            visita,
            activo
        );
    }
}

export default AccessPermission;
